import { createContext, useContext, useEffect, useMemo } from 'react'

export type SelectableItemContextValue = {
  selectedIdLookup: Record<string, boolean>
  toggleSelect: (id: string) => void
  clearSelection: () => void
}

export const SelectableItemContext = createContext<SelectableItemContextValue>({
  selectedIdLookup: {},
  toggleSelect: () => null,
  clearSelection: () => null,
})

export const useSelectableItemContext = () => useContext(SelectableItemContext)

export const useSelectedIdsList = () => {
  const { selectedIdLookup } = useSelectableItemContext()

  return useMemo(() => {
    const selected = []
    for (const [id, status] of Object.entries(selectedIdLookup)) {
      if (status) selected.push(id)
    }
    return selected
  }, [selectedIdLookup])
}

interface ListSelectionResetProps {
  key: string
}
export const ListSelectionReset = ({ key }: ListSelectionResetProps) => {
  const { clearSelection } = useSelectableItemContext()
  useEffect(() => {
    clearSelection()
  }, [key, clearSelection])
  return null
}
